import { getPmsTsApiV1Client } from '@/api/pmsApiV1Client';
import type { apiV1Contract } from '@montugroup/pms-api-contracts';
import type { z } from 'zod';

export type PatientConsentQuestion = z.infer<
  (typeof apiV1Contract)['patientConsent']['getConsentQuestions']['responses']['200']
>[number];

const { useQuery, keys } = getPmsTsApiV1Client().patientConsent.getConsentQuestions;

export const useGetPatientConsentQuestions = () => {
  return useQuery({ queryKey: keys, queryData: { query: {} } });
};
